export default __webpack_public_path__ + "static/media/userImg.d7d4433a.svg";